module.exports = __webpack_public_path__ + "img/empty-icon.69da3ce2.png";